export default __webpack_public_path__ + "static/vogue_colors_2-47c2aa97b1417315650828e7e207e31e.png";